import '../../styles/templates/product.bundler.css';
import ReactDOM from "react-dom";
import { Bundler } from "../react-components/bundler";

const root = document.getElementById("bundler");
ReactDOM.render(<Bundler />, root);
